// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: sans-serif;
}
.content {
  display: grid;
  grid-template-columns: 1fr 4fr 2fr;
  margin: 1rem;
}
#projectFolders {
  display: grid;
  grid-template-rows: 2rem 5rem 5rem;
  background-color: rgb(236, 233, 233);
  border-radius: 5px;
  min-width: 100%;
  row-gap: 0.5rem;
}
#projectFolder {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
}
#priorityFolder {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
}
#mainContent {
  display: grid;
  grid-template-rows: 2rem 2rem 2fr;
}
#mainContent button {
  border-radius: 5px;
}
#todoPage {
  background-color: rgb(236, 233, 233);
  border-radius: 5px;
}
#projectFolders,
#mainContent,
#todoPage {
  padding: 0 1rem;
}
#mainContent > #currentProjectContainer {
  display: flex;
  flex-direction: row;
}
#currentProjectContainer > h2 {
  padding-right: 1rem;
}
#addTodoButton {
  display: flex;
  width: 100%;
}
#addTodoButton::before {
  content: "+";
}
#bottomDisplay {
  display: flex;
  flex-direction: column;
}
#bottomDisplay > button {
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  justify-items: center;
  margin-bottom: 0.2rem;
}
#bottomDisplay > button::before {
  content: "";
}

#bottomDisplay > button::after {
  content: ">";
}
#bottomDisplay > button.taskCompleteTrue::before {
  content: "✓";
  color: rgb(9, 247, 9);
}

#addTodoButton {
  font-size: 1.3rem;
  min-height: 0.4rem;
}
#calendar {
  font-size: 1rem;
}
#middleDisplay {
  margin-bottom: 1rem;
}
.todoProjectButton {
  font-size: 1.1rem;
}
.todoProjectButton.high {
  background-color: rgb(226, 32, 32);
  color: white;
}
.todoProjectButton.medium {
  background-color: rgb(223, 175, 44);
  color: white;
}
.todoProjectButton.low {
  background-color: rgb(16, 102, 16);
  color: white;
}
#labels {
  display: grid;
  grid-template-rows: repeat(5, 1fr);
}
#todoInformation {
  font-size: 2rem;
}
#todoPage > #todoInformationPage {
  color: rgb(71, 70, 70);
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  text-overflow: ellipsis;
}
#todoInformationPage > h5 > p {
  font-size: 1.5rem;
  color: black;
}
#informationButtons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
#labelTitle::before,
#labelDueDate::before {
  content: "*";
  color: red;
}
#labels > label {
  min-width: 5rem;
  max-width: 100%;
}
#labels > label > * {
  width: 100%;
}
#highPriorityButton::before {
  content: "■";
  color: rgb(226, 32, 32);
  font-size: 1.2rem;
}
#mediumPriorityButton::before {
  content: "■";
  color: rgb(223, 175, 44);
  font-size: 1.2rem;
}
#lowPriorityButton::before {
  content: "■";
  color: rgb(16, 102, 16);
  font-size: 1.2rem;
}
#projectFolders button {
  display: grid;
  grid-template-columns: 10% 90%;
  align-content: center;
  max-height: 100%;
}
#submitButton,
#editButton {
  background-color: yellow;
  color: black;
  border-radius: 5px;
  font-size: 1rem;
}
#editButton {
  border: yellow;
}
#completeButton {
  background-color: green;
  color: black;
  border: green;
  border-radius: 5px;
  font-size: 0.9rem;
}
button {
  font-weight: bold;
}
#delButton {
  background-color: red;
  color: black;
  border: red;
  border-radius: 5px;
}
input,
select {
  border-radius: 5px;
  border: black solid 1px;
}
input:invalid {
  border: 1px solid red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;;EAEE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\nbody {\n  font-family: sans-serif;\n}\n.content {\n  display: grid;\n  grid-template-columns: 1fr 4fr 2fr;\n  margin: 1rem;\n}\n#projectFolders {\n  display: grid;\n  grid-template-rows: 2rem 5rem 5rem;\n  background-color: rgb(236, 233, 233);\n  border-radius: 5px;\n  min-width: 100%;\n  row-gap: 0.5rem;\n}\n#projectFolder {\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n}\n#priorityFolder {\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n}\n#mainContent {\n  display: grid;\n  grid-template-rows: 2rem 2rem 2fr;\n}\n#mainContent button {\n  border-radius: 5px;\n}\n#todoPage {\n  background-color: rgb(236, 233, 233);\n  border-radius: 5px;\n}\n#projectFolders,\n#mainContent,\n#todoPage {\n  padding: 0 1rem;\n}\n#mainContent > #currentProjectContainer {\n  display: flex;\n  flex-direction: row;\n}\n#currentProjectContainer > h2 {\n  padding-right: 1rem;\n}\n#addTodoButton {\n  display: flex;\n  width: 100%;\n}\n#addTodoButton::before {\n  content: \"+\";\n}\n#bottomDisplay {\n  display: flex;\n  flex-direction: column;\n}\n#bottomDisplay > button {\n  display: grid;\n  grid-template-columns: 2rem 1fr 2rem;\n  justify-items: center;\n  margin-bottom: 0.2rem;\n}\n#bottomDisplay > button::before {\n  content: \"\";\n}\n\n#bottomDisplay > button::after {\n  content: \">\";\n}\n#bottomDisplay > button.taskCompleteTrue::before {\n  content: \"✓\";\n  color: rgb(9, 247, 9);\n}\n\n#addTodoButton {\n  font-size: 1.3rem;\n  min-height: 0.4rem;\n}\n#calendar {\n  font-size: 1rem;\n}\n#middleDisplay {\n  margin-bottom: 1rem;\n}\n.todoProjectButton {\n  font-size: 1.1rem;\n}\n.todoProjectButton.high {\n  background-color: rgb(226, 32, 32);\n  color: white;\n}\n.todoProjectButton.medium {\n  background-color: rgb(223, 175, 44);\n  color: white;\n}\n.todoProjectButton.low {\n  background-color: rgb(16, 102, 16);\n  color: white;\n}\n#labels {\n  display: grid;\n  grid-template-rows: repeat(5, 1fr);\n}\n#todoInformation {\n  font-size: 2rem;\n}\n#todoPage > #todoInformationPage {\n  color: rgb(71, 70, 70);\n  display: grid;\n  grid-template-rows: repeat(5, 1fr);\n  text-overflow: ellipsis;\n}\n#todoInformationPage > h5 > p {\n  font-size: 1.5rem;\n  color: black;\n}\n#informationButtons {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n#labelTitle::before,\n#labelDueDate::before {\n  content: \"*\";\n  color: red;\n}\n#labels > label {\n  min-width: 5rem;\n  max-width: 100%;\n}\n#labels > label > * {\n  width: 100%;\n}\n#highPriorityButton::before {\n  content: \"■\";\n  color: rgb(226, 32, 32);\n  font-size: 1.2rem;\n}\n#mediumPriorityButton::before {\n  content: \"■\";\n  color: rgb(223, 175, 44);\n  font-size: 1.2rem;\n}\n#lowPriorityButton::before {\n  content: \"■\";\n  color: rgb(16, 102, 16);\n  font-size: 1.2rem;\n}\n#projectFolders button {\n  display: grid;\n  grid-template-columns: 10% 90%;\n  align-content: center;\n  max-height: 100%;\n}\n#submitButton,\n#editButton {\n  background-color: yellow;\n  color: black;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n#editButton {\n  border: yellow;\n}\n#completeButton {\n  background-color: green;\n  color: black;\n  border: green;\n  border-radius: 5px;\n  font-size: 0.9rem;\n}\nbutton {\n  font-weight: bold;\n}\n#delButton {\n  background-color: red;\n  color: black;\n  border: red;\n  border-radius: 5px;\n}\ninput,\nselect {\n  border-radius: 5px;\n  border: black solid 1px;\n}\ninput:invalid {\n  border: 1px solid red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
